import React, { useState } from 'react';
import PickerList from '../components/PickerList';
import { STATES } from '../data/states';

const MobileState = () => {
  const [selected, setSelected] = useState('');

  return <PickerList options={STATES} selected={selected} onSelect={setSelected} />;
};

export default MobileState;
